import {createContext,useContext} from 'solid-js';

/* Provides links to the frontend page to link to for previews */
const LinkContext = createContext();

export function LinkProvider(P:{link:string})
{
	return (
		<LinkContext.Provider value={P.link}>
			{P.children}
		</LinkContext.Provider>
	);
}

export function useLink()
{
	return useContext(LinkContext) as string;
}

